"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sizes = void 0;
/**
 * Whitelabel depending sizes
 */
exports.sizes = {
    logoWidth: 72,
    logoHeight: 87
};
//# sourceMappingURL=relic.js.map